export default __webpack_public_path__ + "static/media/00.2dc2ab44.jpg";